<div class="container-fluid">
  <div class="row row-padding">
    <div class="col centered">
      <h3>Add Vendor</h3>
    </div>
    <div class="col-auto">
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="close()"
      ></button>
    </div>
  </div>
  @if (flagsLoaded) {
    <div class="row row-padding justify-content-center">
      <div class="col-auto">
        <p>{{ promptText }}</p>
      </div>
    </div>
    <div class="row row-padding">
      @if (allowClientRegisteredVendors) {
        <div [class]="allowExemptVendors ? 'col-6' : 'col-10'">
          <button
            type="button"
            class="btn btn-primary h-100"
            (click)="addClientRegisteredVendor()"
          >
            Add {{ businessVerifiedOrNonVerified | uppercase }} VENDOR
          </button>
        </div>
      }
      @if (allowExemptVendors) {
        <div [class]="allowClientRegisteredVendors ? 'col-4' : 'col-10'">
          <button
            type="button"
            class="btn btn-primary h-100"
            (click)="addExemptVendor()"
          >
            Add exempt vendor
          </button>
        </div>
      }
      <div class="col-2">
        <button type="button" class="btn btn-danger h-100" (click)="close()">
          Cancel
        </button>
      </div>
    </div>
  }
</div>
